import React, { useEffect, useState, lazy } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
import { CheckCircleIcon, StarIcon, ChevronRightIcon } from 'lucide-react';
import { MetaPixel, trackAddToCart } from '../components/MetaPixel';
export const Advertorial = () => {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-49">
      <MetaPixel data-id="element-50" />
      <Header data-id="element-51" />
      <main className="flex-grow" data-id="element-52">
        <div className="container mx-auto px-4 py-6" data-id="element-53">
          <div className="mb-6 text-center" data-id="element-54">
            <span className="bg-teal-100 text-teal-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-55">
              Gezondheidsnieuws
            </span>
            <h1 className="text-2xl md:text-3xl font-bold mt-3 mb-2" data-id="element-56">
              Eindelijk Vrije Voeten: De Eenvoudige Pleister Die Jarenlange
              Verborgen Schaamte Beëindigt
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-57">
              Gepubliceerd: 15 juni 2023 | Door Dr. Robert Wilson
            </p>
          </div>
          <div className="prose max-w-none" data-id="element-58">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oaXFLpuMmpogXaJSBYmxmy/Google_AI_Studio_2025-08-28T15_17_28.508Z.png" alt="Vrouw die zelfverzekerd op sandalen loopt op een zonnige dag" className="w-full object-cover rounded-lg mb-6" loading="lazy" width="800" height="500" data-id="element-59" />
            <p className="font-medium text-lg mb-4" data-id="element-60">
              Verberg je je voeten vanwege gênante nagelschimmel? Je bent niet
              alleen. Miljoenen mensen lijden in stilte, maar een
              doorbraakoplossing verandert levens.
            </p>
            <p className="mb-4" data-id="element-61">
              Al tientallen jaren worstelen mensen met hardnekkige nagelschimmel
              die onmogelijk te elimineren lijkt. Traditionele behandelingen
              blijken vaak ineffectief, waardoor mensen achterblijven met
              verkleurde, broze nagels die zowel fysiek ongemak als emotionele
              stress veroorzaken.
            </p>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pE9wXRAFzBmVRps5TzPJSn/Google_AI_Studio_2025-08-28T15_28_45.278Z.png" alt="Persoon die zorgvuldig zijn voeten droogt met een witte handdoek" className="w-full object-cover rounded-lg my-6" loading="lazy" width="800" height="500" data-id="element-62" />
            <div className="bg-[#F0FDFA] p-5 rounded-lg my-6 border-l-4 border-teal-500 italic" data-id="element-63">
              <p className="text-lg" data-id="element-64">
                "Ik heb alles geprobeerd - dure crèmes, huismiddeltjes, zelfs
                orale medicijnen met angstaanjagende bijwerkingen. Niets werkte
                totdat ik deze pleisters ontdekte. Voor het eerst in 15 jaar
                schaam ik me niet meer voor mijn voeten."
              </p>
              <p className="text-right font-medium" data-id="element-65">
                — Michael T., Geverifieerde Klant
              </p>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-66">
              De Verborgen Epidemie Die 1 op de 10 Nederlanders Treft
            </h2>
            <p className="mb-4" data-id="element-67">
              Nagelschimmel (onychomycose) treft ongeveer 10% van de volwassen
              bevolking, met cijfers die oplopen tot bijna 50% bij mensen ouder
              dan 70 jaar. Ondanks de prevalentie zijn effectieve
              behandelingsmogelijkheden beperkt gebleven—tot nu.
            </p>
            <p className="mb-4" data-id="element-68">
              "Het probleem met traditionele behandelingen is dat ze het
              nagelbed niet effectief doordringen," legt Dr. James Chen uit, een
              toonaangevende dermatoloog. "De meeste topische oplossingen kunnen
              de schimmel gewoon niet bereiken waar deze leeft, en orale
              medicijnen brengen aanzienlijke risico's van leverschade en andere
              bijwerkingen met zich mee."
            </p>
            <div className="bg-gray-100 p-4 rounded-lg my-6" data-id="element-69">
              <h3 className="font-bold mb-2" data-id="element-70">
                Succesverhaal: Sarah's Transformatie
              </h3>
              <p className="italic mb-2" data-id="element-71">
                "Nadat mijn nagelschimmel zich had verspreid naar zes tenen, was
                ik wanhopig. Ik stopte met naar yogales gaan omdat ik me zo
                schaamde. Deze schimmelpleisters veranderden alles. Na slechts
                drie weken kon ik zien hoe er een heldere, gezonde nagel
                groeide. Nu zijn mijn voeten volledig getransformeerd!"
              </p>
              <div className="flex items-center" data-id="element-72">
                <div className="flex" data-id="element-73">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-74" />)}
                </div>
                <span className="ml-2 text-sm font-medium" data-id="element-75">
                  Sarah K. - Geverifieerde Aankoop
                </span>
              </div>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-76">
              De Wetenschap Achter FungusFreePatch™: Hoe Het Werkt
            </h2>
            <p className="mb-4" data-id="element-77">
              Na jaren van onderzoek hebben wetenschappers FungusFreePatch™
              ontwikkeld, een revolutionaire behandeling die krachtige
              antischimmelverbindingen rechtstreeks naar de infectieplek levert
              via een gepatenteerd transdermaal toedieningssysteem.
            </p>
            <div className="my-6" data-id="element-78">
              <h3 className="font-bold mb-3" data-id="element-79">Het 3-Stappen Proces:</h3>
              <ol className="list-decimal pl-5 space-y-2" data-id="element-80">
                <li className="font-medium" data-id="element-81">
                  <span className="font-bold" data-id="element-82">Penetratie:</span> De
                  micronaaldtechnologie van de pleister creëert microscopische
                  kanalen in de nagel, waardoor de actieve ingrediënten het
                  harde nageloppervlak kunnen omzeilen.
                </li>
                <li className="font-medium" data-id="element-83">
                  <span className="font-bold" data-id="element-84">Eliminatie:</span> Een krachtige
                  mix van tea tree olie, oregano-extract en farmaceutische
                  antischimmelmiddelen valt de schimmel direct aan bij de bron.
                </li>
                <li className="font-medium" data-id="element-85">
                  <span className="font-bold" data-id="element-86">Herstel:</span> Helende
                  verbindingen voeden het nagelbed en bevorderen de groei van
                  gezond nieuw nagelweefsel.
                </li>
              </ol>
            </div>
            <div className="bg-[#F0FDFA] p-5 rounded-lg my-6 border-l-4 border-teal-500 italic" data-id="element-87">
              <p className="text-lg" data-id="element-88">
                "Wat deze aanpak revolutionair maakt, is het vermogen om de
                actieve ingrediënten direct te leveren waar de schimmel leeft.
                Traditionele behandelingen kunnen simpelweg niet tippen aan dit
                niveau van gerichte toediening."
              </p>
              <p className="text-right font-medium" data-id="element-89">
                — Dr. Elizabeth Morgan, Podoloog
              </p>
            </div>
            <div className="my-8" data-id="element-90">
              <h3 className="font-bold text-lg mb-4" data-id="element-91">
                Waarom Mensen Overstappen op FungusFreePatch™
              </h3>
              <div className="space-y-4" data-id="element-92">
                <div className="flex" data-id="element-93">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-94">
                    1
                  </div>
                  <div data-id="element-95">
                    <h4 className="font-bold" data-id="element-96">Geen Schaamte Meer</h4>
                    <p className="text-gray-700" data-id="element-97">
                      Gebruikers melden dat ze voor het eerst in jaren met
                      vertrouwen sandalen kunnen dragen en op blote voeten
                      kunnen lopen.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-98">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-99">
                    2
                  </div>
                  <div data-id="element-100">
                    <h4 className="font-bold" data-id="element-101">Snelle, Zichtbare Resultaten</h4>
                    <p className="text-gray-700" data-id="element-102">
                      Hoewel volledige behandeling tijd kost, melden veel
                      gebruikers al na 10-14 dagen verbetering te zien.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-103">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-104">
                    3
                  </div>
                  <div data-id="element-105">
                    <h4 className="font-bold" data-id="element-106">Geen Bijwerkingen</h4>
                    <p className="text-gray-700" data-id="element-107">
                      In tegenstelling tot orale medicijnen die je lever kunnen
                      beschadigen, werkt FungusFreePatch™ lokaal zonder
                      systemische bijwerkingen.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-108">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-109">
                    4
                  </div>
                  <div data-id="element-110">
                    <h4 className="font-bold" data-id="element-111">Eenvoudige Toepassing</h4>
                    <p className="text-gray-700" data-id="element-112">
                      Breng de pleister gewoon aan voor het slapengaan en
                      verwijder hem 's ochtends. Geen rommelige crèmes of
                      ingewikkelde procedures.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-113">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-114">
                    5
                  </div>
                  <div data-id="element-115">
                    <h4 className="font-bold" data-id="element-116">Kosteneffectief</h4>
                    <p className="text-gray-700" data-id="element-117">
                      Vergeleken met receptgeneesmiddelen en doktersbezoeken
                      biedt FungusFreePatch™ een betaalbaardere oplossing met
                      betere resultaten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg my-6" data-id="element-118">
              <h3 className="font-bold mb-2" data-id="element-119">Deskundige Mening</h3>
              <p className="italic mb-2" data-id="element-120">
                "In mijn 25 jaar praktijk heb ik nog nooit een behandeling
                gezien die zo effectief is als deze schimmelpleisters. De
                voor-en-na foto's van mijn patiënten zijn werkelijk opmerkelijk.
                Ik raad ze nu aan als eerstelijnsbehandeling voor
                nagelschimmel."
              </p>
              <p className="text-sm font-medium" data-id="element-121">
                - Dr. Richard Johnson, Specialist Podiatrische Geneeskunde
              </p>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-122">
              Echte Mensen, Echte Resultaten
            </h2>
            <div className="grid md:grid-cols-2 gap-6 my-6" data-id="element-123">
              <div className="bg-gray-100 p-4 rounded-lg" data-id="element-124">
                <div className="flex items-center mb-3" data-id="element-125">
                  <div className="flex" data-id="element-126">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-127" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-128">
                    Geverifieerde Aankoop
                  </span>
                </div>
                <p className="italic mb-2" data-id="element-129">
                  "Ik had 8 jaar lang nagelschimmel en heb alles geprobeerd.
                  Binnen een maand na het gebruik van deze pleisters kon ik
                  gezonde nagel zien groeien. Het is nu 3 maanden later en mijn
                  nagels zien er weer helemaal normaal uit!"
                </p>
                <p className="text-sm font-medium" data-id="element-130">- David R.</p>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg" data-id="element-131">
                <div className="flex items-center mb-3" data-id="element-132">
                  <div className="flex" data-id="element-133">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-134" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-135">
                    Geverifieerde Aankoop
                  </span>
                </div>
                <p className="italic mb-2" data-id="element-136">
                  "Als diabeticus maakte ik me zorgen dat mijn nagelschimmel zou
                  leiden tot ernstigere complicaties. Mijn arts raadde deze
                  pleisters aan, en ze hebben een ongelooflijk verschil gemaakt.
                  Geen dikke, gele nagels meer!"
                </p>
                <p className="text-sm font-medium" data-id="element-137">- Patricia M.</p>
              </div>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iuPpbmWDESaAeVMjaiQChw/Google_AI_Studio_2025-08-28T15_33_42.526Z.png" alt="Groep vrouwen die buiten met zelfvertrouwen van tijd samen genieten" className="w-full object-cover rounded-lg my-6" loading="lazy" width="800" height="500" data-id="element-138" />
          </div>
          <div className="mt-8 mb-12 text-center" data-id="element-139">
            <h2 className="text-2xl font-bold mb-4" data-id="element-140">
              Klaar om je Voeten te Bevrijden van Schimmel?
            </h2>
            <p className="mb-6" data-id="element-141">
              Sluit je aan bij duizenden tevreden klanten die hun nagels hebben
              getransformeerd met FungusFreePatch™.
            </p>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5PcrtcvvJwRQ9hCzBacXFK/Google_AI_Studio_2025-08-28T15_15_10.481Z.png" alt="Vrouw die zelfverzekerd op sandalen loopt op een zonnige dag" className="w-full object-cover rounded-lg mb-6" loading="lazy" width="800" height="500" data-id="element-142" />
            <CTAButton text="Bekijk FungusFreePatch™ Details" to="/pdp" fullWidth={true} data-id="element-143" />
          </div>
        </div>
      </main>
      <Footer data-id="element-144" />
      {/* Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 transition-transform duration-300 ${isSticky ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-145">
        <div className="container mx-auto" data-id="element-146">
          <Link to="/pdp" className="flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackAddToCart} data-id="element-147">
            Doorgaan → Productdetails
            <ChevronRightIcon size={18} className="ml-1" data-id="element-148" />
          </Link>
        </div>
      </div>
    </div>;
};